import fetch from "fetch-retry";

export default fetch(global.fetch);
